import { render, staticRenderFns } from "./DormitoryIndex.vue?vue&type=template&id=466e1bc6&scoped=true&"
import script from "./DormitoryIndex.vue?vue&type=script&lang=js&"
export * from "./DormitoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryIndex.vue?vue&type=style&index=0&id=466e1bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e1bc6",
  null
  
)

export default component.exports